import { BrowserModule } from '@angular/platform-browser';
import { enableProdMode, NgModule, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';

import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { EventModule } from './event/event.module';

import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { RouteNotFoundComponent } from './shared/route-not-found/route-not-found.component';
import { AppMenuComponent } from './menus/app-menu/app-menu.component';
import { EventMenuComponent } from './menus/event-menu/event-menu.component';
import { NavigationModule } from './navigation/navigation.module';
import { MenuStore } from './menus/service/menu.store';
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';
import { VersionComponent } from './shared/version/version.component';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { EventSearchFilterComponent } from './menus/event-search-filter/event-search-filter.component';
import { TranslateModule } from './ng2-translate.config';
import { HttpClientModule } from '@angular/common/http';


const routes: Routes = [
  { path: 'version', component: VersionComponent },
  { path: '**', component: RouteNotFoundComponent }
];

@NgModule( {
  declarations: [
    AppComponent,
    AppMenuComponent,
    EventMenuComponent,
    EventSearchFilterComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    AuthModule,
    EventModule,
    NavigationModule,
    UserModule,
    SharedModule,
    TranslateModule,
    HttpClientModule,
    // enable HashLocationStrategy
    // https://angular.io/docs/ts/latest/guide/router.html#!#browser-url-styles
    RouterModule.forRoot( routes, { useHash: true} ),
    Angulartics2Module.forRoot([ Angulartics2GoogleAnalytics ])
  ],
  providers: [ MenuStore ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/app.module.ts